// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__iz7YO","topLabel":"styles_topLabel__NZMzh","topLabelVal":"styles_topLabelVal__Drt+7"};